
import tenant from '../config/tenant';

const EMP_BASE = `${tenant.api.baseUrl}/EMP`;

const buildHeaders = (token) => {
  const headers = { 'Content-Type': 'application/json' };
  const key = token || localStorage.getItem('AuthKey') || localStorage.getItem('auth-key') || localStorage.getItem('auth_key');
  if (key) {
    headers['auth-key'] = key; 
  }
  return headers;
};

const handleResponse = async (res) => {
  if (!res.ok) {
    const text = await res.text().catch(() => `HTTP ${res.status}`);
    throw new Error(text || `API Error: ${res.status}`);
  }
  return res.json();
};

const empService = {
  getAllEmployees: (token) =>
    fetch(`${EMP_BASE}/GetAllEMP`, { method: 'GET', headers: buildHeaders(token) }).then(handleResponse),

  addEmployee: (data, token) =>
    fetch(`${EMP_BASE}/AddEMP`, {
      method: 'POST', headers: buildHeaders(token), body: JSON.stringify(data),
    }).then(handleResponse),

  getEMPByServiceNo: (serviceNo, token) =>
    fetch(`${EMP_BASE}/GetEMPByServiceNo?p_ced_service_no=${encodeURIComponent(serviceNo)}`, {
      method: 'GET', headers: buildHeaders(token),
    }).then(handleResponse),

  // Dropdown APIs
  getEMPCat:          (token) => fetch(`${EMP_BASE}/GetEMPCat`,          { headers: buildHeaders(token) }).then(handleResponse),
  getProfDetails:     (token) => fetch(`${EMP_BASE}/GetProfDetails`,      { headers: buildHeaders(token) }).then(handleResponse),
  getLocDetails:      (token) => fetch(`${EMP_BASE}/GetLocDetails`,       { headers: buildHeaders(token) }).then(handleResponse),
  getDepDetails:      (token) => fetch(`${EMP_BASE}/GetDepDetails`,       { headers: buildHeaders(token) }).then(handleResponse),
  getDevDetails:      (token) => fetch(`${EMP_BASE}/GetDevDetails`,       { headers: buildHeaders(token) }).then(handleResponse),
  getShiftTypes:      (token) => fetch(`${EMP_BASE}/GetShiftTypes`,       { headers: buildHeaders(token) }).then(handleResponse),
  getShiftRules:      (token) => fetch(`${EMP_BASE}/GetShiftRules`,       { headers: buildHeaders(token) }).then(handleResponse),
  getProDetails:      (token) => fetch(`${EMP_BASE}/GetProDetails`,       { headers: buildHeaders(token) }).then(handleResponse),
  getDisDetails:      (token) => fetch(`${EMP_BASE}/GetDisDetails`,       { headers: buildHeaders(token) }).then(handleResponse),
  getPoliceStDetails: (token) => fetch(`${EMP_BASE}/GetPoliceStDetails`,  { headers: buildHeaders(token) }).then(handleResponse),
  getCDLCal:          (token) => fetch(`${EMP_BASE}/GetCDLCal`,           { headers: buildHeaders(token) }).then(handleResponse),
  getCDLCalDate:      (token) => fetch(`${EMP_BASE}/GetCDLCalDate`,       { headers: buildHeaders(token) }).then(handleResponse),
};

export default empService;
